import type { MutableRefObject } from 'react';
import type { AppDispatch } from '@/store';
import { clearDeferredSendForChat, clearPendingMessageForChat } from '@/store';

export type CancelDeferredChatSendParams = {
  dispatch: AppDispatch;
  chatKey: string;
  prompt: string;
  setDeferredSend: (value: null) => void;
  autoSendDeferredRef: MutableRefObject<boolean>;
  setChatQuery: (value: string) => void;
};

/** Stops a deferred send (waiting for file processing) and restores the prompt in the input. */
export function cancelDeferredChatSend({
  dispatch,
  chatKey,
  prompt,
  setDeferredSend,
  autoSendDeferredRef,
  setChatQuery,
}: CancelDeferredChatSendParams): void {
  dispatch(clearPendingMessageForChat({ chatId: chatKey }));
  dispatch(clearDeferredSendForChat({ chatId: chatKey }));
  setDeferredSend(null);
  autoSendDeferredRef.current = false;
  if (prompt) {
    setChatQuery(prompt);
  }
}
